import React, { useState } from "react";
import "../../css/Inicio/oficina-empleo.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const redes = [
  {
    href: "https://www.instagram.com/oficinadeempleooliva?igsh=bXVoOG54dW42Y3Ay",
    icon: faInstagram,
    label: "Instagram",
  },
  {
    href: "https://api.whatsapp.com/send/?phone=5493532447906&text=Hola%2C+me+contacto+para+realizar+una+consulta.&app_absent=0",
    icon: faWhatsapp,
    label: "WhatsApp",
  },
];

const acordeon = [
  {
    titulo: (
      <>
        <i className="fa-solid fa-briefcase" style={{ marginRight: 5 }}></i>
        Orientación laboral
      </>
    ),
    contenido:
      "Dirigido a las personas que buscan insertarse por primera vez en el mercado laboral, a quienes tienen necesidad de reconvertir su perfil ocupacional y/o que presentan dificultades especiales para el ingreso en el mercado laboral. Este servicio lo brindamos mediante asesoramiento individual en la primer entrevista o mediante taller grupal.",
  },
  {
    titulo: (
      <>
        <i className="fa-solid fa-magnifying-glass" style={{ marginRight: 6 }}></i>
        Apoyo a la búsqueda de empleo
      </>
    ),
    contenido:
      "Dirigido a personas que, aunque reúnen condiciones de empleabilidad, requieren asistencia para el diseño de estrategias y mecanismos adecuados para la búsqueda de empleo a través de: información sobre el mercado de trabajo local, asistencia para elaborar el currículum vitae y una agenda personal de búsqueda de empleo, pautas para el adecuado desempeño en entrevistas laborales, técnicas para presentarse a una entrevista de trabajo, etc. Este servicio lo brindamos mediante asesoramiento individual en la primer entrevista o mediante taller grupal.",
  },
  {
    titulo: (
      <>
        <i className="fa-solid fa-people-robbery" style={{ marginRight: 5 }}></i>
        Orientación para el trabajo independiente
      </>
    ),
    contenido:
      "Este servicio tiene por objetivo brindar herramientas para que las personas interesadas puedan reflexionar acerca de su potencial perfil emprendedor y sus posibilidades reales de desarrollar un emprendimiento. Este servicio lo brindamos mediante asesoramiento individual en la primer entrevista o mediante taller grupal.",
  },
  {
    titulo: (
      <>
        <i className="fa-solid fa-handshake" style={{ marginRight: 5 }}></i>
        Intermediación Laboral
      </>
    ),
    contenido: (
      <>
        El objetivo de este servicio es vincular a los postulantes con ofertas de empleo, a partir de la derivación hacia un empleo adecuado a su perfil laboral, cubriendo vacantes previamente solicitadas por los empleadores y registradas en la base de datos de la Oficina de Empleo. Para registrarte ingresá a{" "}
        <a className="link-primary" href="https://www.portalempleo.gob.ar/Registro" target="_blank" rel="noopener noreferrer">
          https://www.portalempleo.gob.ar/Registro
        </a>
      </>
    ),
  },
  {
    titulo: (
      <>
        <i className="fa-solid fa-graduation-cap" style={{ marginRight: 5 }}></i>
        Información y derivaciones a instituciones educativas y/o formación Profesional
      </>
    ),
    contenido: (
      <>
        Orientamos a los postulantes que buscan empleo o quieran perfeccionar su perfil laboral hacia actividades de capacitación como complemento y como transición al empleo. Puedes ver la oferta de capacitaciones vigentes en{" "}
        <a className="link-primary" href="https://www.portalempleo.gob.ar/BuscadorCursos" target="_blank" rel="noopener noreferrer">
          https://www.portalempleo.gob.ar/BuscadorCursos
        </a>
      </>
    ),
  },
  {
    titulo: (
      <>
        <i className="fa-solid fa-circle-info" style={{ marginRight: 5 }}></i>
        Información y derivaciones a servicios sociales
      </>
    ),
    contenido:
      "Orientamos a personas con problemáticas no vinculadas con el empleo pero que dificultan su inserción laboral y las derivamos a servicios sociales como por ejemplo alimentación, salud, cuidado de niños, documentación, entre otros.",
  },
  {
    titulo: (
      <>
        <i className="fa-solid fa-address-card" style={{ marginRight: 5 }}></i>
        Información y derivaciones a programas de empleo
      </>
    ),
    contenido:
      "Asesoramos sobre los diferentes programas de promoción del empleo que se encuentran vigentes, a fin de atender las particularidades de los trabajadores y trabajadoras en búsqueda laboral activa y facilitar su transición hacia el empleo formal.",
  },
];

const OficinaEmpleo = () => {
  const [open, setOpen] = useState(null);

  return (
    <div className="oficina-de-empleo">
      {/* Fondo decorativo */}
      <div className="logo-oficina">
        <div className="logo-oficina-redes">
          {redes.map((r, i) => (
            <a
              key={i}
              href={r.href}
              className={`logo-red ${r.label.toLowerCase()}-oficina`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={r.label}
              style={{ marginLeft: i === 0 ? 0 : 18 }}
            >
              <FontAwesomeIcon icon={r.icon} size="2x" />
            </a>
          ))}
        </div>
      </div>
      <div className="oficina-main">
        {/* Logo institucional destacado */}
        <div className="oficina-header-flex">
          <img
            src={require("../img/logo-1024x280.jpeg")}
            alt="Logo Oficina de Empleo"
            className="logo-oficina-img"
          />
          <a
            href="https://portalempleo.gob.ar/"
            className="boton-oficina"
            target="_blank"
            rel="noopener noreferrer"
          >
            REGISTRÁ TUS DATOS EN EL PORTAL EMPLEO
          </a>
        </div>
        <p className="texto">
          La <strong>Oficina de Empleo Municipal</strong> es un espacio destinado a brindar servicios tanto a las personas que buscan empleo como a las empresas que necesitan contratar personal.
          Esta oficina tiene como objetivo mejorar las posibilidades de inserción en el mercado laboral de personas desocupadas, subocupadas, o con necesidades de reconvertir su perfil laboral; ofreciéndoles los siguientes servicios de empleo:
        </p>
        <div className="acordeon-oficina">
          {acordeon.map((item, idx) => (
            <div className="acordeon-item" key={idx}>
              <button
                className={`acordeon-btn${open === idx ? " open" : ""}`}
                onClick={() => setOpen(open === idx ? null : idx)}
                aria-expanded={open === idx}
              >
                {item.titulo}
              </button>
              <div className={`acordeon-content${open === idx ? " show" : ""}`}>
                <div>
                  {item.contenido}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OficinaEmpleo;